export class AddBusinessesToQueue {
  static readonly  type = '[Business] Add Businesses to Queue';

  constructor(public businessIds: number[]) {
  }
}

export class GetBusinesses {
  static readonly type = '[Business] GetBusinesses';

  constructor(public refresh: boolean = false) {}
}

export class GetBusiness {
  static readonly type = '[Business] Get Individual Business';
  constructor(public borrowerId: number) {}
}

export class SnoozeBusinesses {
  static readonly type = '[Business] SnoozeBusiness';

  constructor(public businessIds: number[]) {
  }
}
